export function normalizeSniResponseCode (code) {
  return code === undefined || code === null ? '' : String(code)
}
